import { css } from 'emotion';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import Slider from 'react-slick';

import arrowLeft from '../assets/groupOption/arrows/group-options-arrow-left.svg';
import arrowRight from '../assets/groupOption/arrows/group-options-arrow-right.svg';
import { BREAKPOINT_SMALL } from '../consts/breakpoints';
import { carouselContainer } from '../styles/carouselContainer';

const containerModifications = css`
  .slick-slider {
    display: flex;
    align-items: center;
    margin: 0px 50px 0px 50px;
    @media (min-width: ${BREAKPOINT_SMALL}) {
      margin: 0px 40px 0px 40px;
    }

    .slick-list {
      flex: 1;
    }
  }
  .slick-next {
    position: absolute;
    right: -30px;
    top: 40%;
    z-index: 1;
    @media (min-width: ${BREAKPOINT_SMALL}) {
      position: absolute;
      right: -30px;
      top: 40%;
      z-index: 1;
    }
  }
  .slick-prev {
    position: absolute;
    left: -30px;
    top: 40%;
    z-index: 1;
    @media (min-width: ${BREAKPOINT_SMALL}) {
      position: absolute;
      left: -30px;
      top: 40%;
      z-index: 1;
    }
  }
  .slick-track {
    display: flex;
  }
  .slick-track .slick-slide {
    display: flex;
    height: auto;
    align-items: center;
    justify-content: center;
  }
`;

const arrow = (arrowImage: string, arrowDirection: string) => css`
  background: url(${arrowImage});
  cursor: pointer;
  position: absolute;
  ${arrowDirection === 'right' &&
    css`
      right: -40px;

      @media (min-width: ${BREAKPOINT_SMALL}) {
        right: -30px;
      }
    `}

  ${arrowDirection === 'left' &&
    css`
      left: -40px;

      @media (min-width: ${BREAKPOINT_SMALL}) {
        left: -30px;
      }
    `}

  top: 50%;
  transform: translateY(-50%);
  display: block;
  height: 9px;
  width: 5px;
  padding-right: 25px;
  background-repeat: no-repeat;
  background-position: center;
`;

interface IArrowProps {
  arrowDirection: 'right' | 'left';
  onClick?(): void;
}

const Arrow = ({ onClick, arrowDirection }: IArrowProps) => {
  const arrowImage = arrowDirection === 'left' ? arrowLeft : arrowRight;

  return <div className={arrow(arrowImage, arrowDirection)} onClick={onClick} role="region" />;
};

interface IGroupOptionSelector {
  children: Array<React.ReactNode>;
  className?: string;
}

export const GroupOptionSelector = observer(({ children, className }: IGroupOptionSelector) => {
  const childrenCount = React.Children.count(children);
  let selectedItemIndex;

  if (children) {
    const index = children.findIndex((element: any) => element && element.props.isSelected);
    if (index < 4) {
      selectedItemIndex = 0;
    }

    if (index === 4) {
      selectedItemIndex = 1;
    }

    if (index > 4) {
      selectedItemIndex = index - 4;
    }
  }

  return (
    <div className={`${carouselContainer} ${containerModifications} ${className}`}>
      <Slider
        arrows
        infinite={false}
        nextArrow={<Arrow arrowDirection="right" />}
        prevArrow={<Arrow arrowDirection="left" />}
        slidesToScroll={1}
        slidesToShow={childrenCount >= 4 ? 4 : childrenCount}
        speed={500}
        initialSlide={selectedItemIndex}
      >
        {children}
      </Slider>
    </div>
  );
});
